import { TableHead, TableRow, TableHeaderText } from '@pocketlaw/tetris';
import { StyledTableHeadCell } from './styled';
export function SearchResultsTableHead(props) {
    const { columnConfigs } = props;
    return (<TableHead>
      <TableRow>
        {columnConfigs.map(column => {
            if (column.label && column.id) {
                return (<StyledTableHeadCell key={column.id} id={column.id} colSpan={column.colSpan} stickyColumn={column.stickyColumn}>
                <TableHeaderText sortId={column.sortId}>{column.label}</TableHeaderText>
              </StyledTableHeadCell>);
            }
            return null;
        })}
      </TableRow>
    </TableHead>);
}
